import axios from 'axios';
import { ROOT_URL } from './urlTypes';
import * as urls from './urlTypes';
import * as types from './actionTypes';
import { toastError } from '../util/toastUtils';
import {
  AddFieldsToAccount,
  encodeObjToQueryParam,
} from '../util/RldAccountUtils';

export const resetGenerateFile = param => async dispatch => {
  dispatch({
    type: types.RLD_TOOL_RESET_GENERATE_FILE,
    payload: param,
  });
};

export const setEmails = (param, allowToGenerateFile) => async dispatch => {
  if (param) {
    dispatch({
      type: types.RLD_TOOL_SET_EMAIL,
      payload: param,
      generateFile: allowToGenerateFile,
    });
  }
};

export const setDictionaryFileStructure = param => async dispatch => {
  if (param) {
    dispatch({
      type: types.RLD_TOOL_SET_DICTIONARY_FILE_STRUCTURE,
      payload: param,
    });
  }
};

export const setExportFileFormat = param => async dispatch => {
  if (param) {
    dispatch({
      type: types.RLD_TOOL_SET_EXPORT_FILE_FORMAT,
      payload: param,
    });
  }
};

export const setFileStructureFormat = param => async dispatch => {
  if (param) {
    dispatch({
      type: types.RLD_TOOL_SET_FILE_STRUCTURE_FORMAT,
      payload: param,
    });
  }
};

export const setSelectedAccount = param => async dispatch => {
  if (param) {
    dispatch({
      type: types.RLD_TOOL_SET_SELECTED_ACCOUNT,
      data: {
        selectedAccount: param,
      },
    });
  }
};

export const getAccountList = (param, userAccountID) => async dispatch => {
  const accounts = await getAccountsData(param);
  try {
    if (accounts) {
      var updateAccounts = AddFieldsToAccount(accounts.data);

      dispatch({
        type: types.RLD_TOOL_SET_ACCOUNTS,
        Account: {
          data: updateAccounts,
          selectedAccount: updateAccounts.find(
            a => a.accountId == userAccountID
          ),
        },
      });
    }
    return accounts;
  } catch (error) {
    console.log(error);
    toastError('Failed to process accounts');
    return false;
  }
};

export const getAccountsData = async param => {
  let url = `${urls.API_GATEWAY_URL}/api/admin-service/accounts`;
  const sq = encodeObjToQueryParam(param);
  if (sq) {
    url = `${urls.API_GATEWAY_URL}/api/admin-service/accounts?${sq}`;
  }
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });

    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return {
        ...response.data,
        data: response.data.data,
      };
    }
    return true;
  } catch (error) {
    console.log(error);
    toastError('No accounts found');
  }
};

// treeloadex API for collecting data for RLD Tool
export const getRldDictionaryTreeLoad = async (
  uid,
  accountId,
  productNo,
  nodeID,
  filter
) => {
  const url = `${ROOT_URL}/dictionary/rld/treeloadex`;
  try {
    const response = await axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        uid,
        accountId,
        productNo,
        node: nodeID,
        filter,
      },
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return {
        ...response.data,
        data: response.data.data,
      };
    }
    return false;
  } catch (error) {
    toastError('Api failed to get treeloadex list for RLD Tool');
    return false;
  }
};

export const getDictionaryTreeLoad = (
  uid,
  accountId,
  productNo,
  nodeID,
  filter
) => async dispatch => {
  const rldDictionaryTree = await getRldDictionaryTreeLoad(
    uid,
    accountId,
    productNo,
    nodeID,
    filter
  );

  if (rldDictionaryTree) {
    dispatch({
      type: types.RLD_TOOL_GET_DICTIONARY_TREE_LOAD,
      payload: {
        rldDictionaryTree: rldDictionaryTree.data,
      },
      nodeID,
    });
  }
};

export const setDictionaryTargetTree = dictionaryTreeTarget => async dispatch => {
  if (dictionaryTreeTarget) {
    dispatch({
      type: types.RLD_TOOL_SET_DICTIONARY_TARGET_TREE,
      payload: {
        dictionaryTarget: dictionaryTreeTarget,
      },
    });
  }
};

export const setSelectedStudy = param => async dispatch => {
  if (param) {
    dispatch({
      type: types.RLD_TOOL_SET_SELECTED_STUDY,
      payload: {
        selectedStudy: param,
      },
    });
  }
};
export const getStudyList = (uid, accountId) => async dispatch => {
  const studies = await getStudyData(uid, accountId);
  if (studies) {
    dispatch({
      type: types.RLD_TOOL_SET_STUDY_DATA,
      payload: {
        studies,
        selectedStudy: studies[0].sl[0],
      },
    });
  }
};

export const getStudyData = async (uid, accountId) => {
  const url = `${urls.ROOT_URL}/users/${uid}/${accountId}/rld/si-studies`;

  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });

    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('No active user or subscription found');
    return false;
  }
};

//  Generate File

export const generateButton = (
  uid,
  accountId,
  pn,
  wt,
  weightTypeName,
  columnSeperator,
  dictionaryFileFormat,
  fileStructureFormat,
  isDictionaryOnly,
  isAllLocalMarkets,
  email,
  nodes,
  timestamp
) => {
  const url = `${urls.API_GATEWAY_URL}${urls.SOCKET_URL}/rld/export/${uid}/${accountId}`;
  return async dispatch => {
    axios({
      url,
      method: 'post',
      withCredentials: true,
      responseType: 'json',
      data: {
        productNo: pn,
        nodes,
        weightType: wt,
        weightTypeName,
        columnSeparator: columnSeperator,
        dictionaryFormat: dictionaryFileFormat,
        dataFormat: fileStructureFormat,
        dictOnly: isDictionaryOnly,
        allLocalMarkets: isAllLocalMarkets,
        emailIds: email,
        timestamp,
      },
    })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.RLD_TOOL_SUCCESS_MESSAGE,
            successMessage: true,
          });
        } else {
          toastError('File generation failed, please try again');
        }
      })
      .catch(error => toastError('File generation failed, please try again'));
  };
};

// weight types

export const updateModuleStudy = (moduleType, study) => ({
  type: types.UPDATE_RLD_MODULE_STUDY,
  study,
  moduleType,
});

export const setIsDictionaryOnly = param => async dispatch => {
  dispatch({
    type: types.RLD_TOOL_SET_IS_DICTIONARY_ONLY,
    payload: param,
  });
};

export const setIsAllLocalMarkets = param => async dispatch => {
  dispatch({
    type: types.RLD_TOOL_SET_IS_ALL_LOCAL_MARKETS,
    payload: param,
  });
};

export const setRldCurrentView = param => async dispatch => {
  dispatch({
    type: types.RLD_TOOL_SET_CURRENT_VIEW,
    payload: param,
  });
};

const getRldListData = async () => {
  const url = `${urls.API_GATEWAY_URL}${urls.SOCKET_URL}/rld/exports`;

  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });

    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('No actilve RLD list found');
    return false;
  }
};

export const getRldList = () => async dispatch => {
  const rldList = await getRldListData();
  if (rldList) {
    dispatch({
      type: types.RLD_TOOL_SET_RLD_LIST_DATA,
      payload: rldList,
    });
  }
};



